// Zentrale Tool-Liste der Rechnerkiste. Quelle für Portal-Grid und Footer.
export const TOOLS = [
  {
    id: "kleinanzeigen",
    name: "Kleinanzeigen-Generator",
    url: "https://kleinanzeigen-generator.de",
    tagline: "Aus einem Produktfoto einen fertigen Verkaufstext für deine Kleinanzeige erstellen.",
    cat: "Verkaufen",
  },
  {
    id: "passt",
    name: "Passt das durch?",
    url: "https://passt-das-durch.de",
    tagline: "Prüfen, ob ein Möbelstück durch Tür, Flur, Aufzug oder Treppenhaus passt.",
    cat: "Umzug & Transport",
  },
  {
    id: "bohrpunkte",
    name: "Bohrpunkte",
    url: "https://bohrpunkte.de",
    tagline: "Bohrpunkte, Abstände und Bohrhöhen für Bilder, Regale und Wandobjekte berechnen.",
    cat: "Heimwerken",
  },
  {
    id: "regalabstand",
    name: "Regalböden-Abstand",
    url: "https://regalabstand.de",
    tagline: "Regalböden gleichmäßig verteilen und eine genaue Markierliste bekommen.",
    cat: "Heimwerken",
  },
  {
    id: "geraetekosten",
    name: "Gerätekosten",
    url: "https://xn--gertekosten-n8a.de",
    display: "gerätekosten.de",
    tagline: "Stromkosten einzelner Geräte pro Tag, Monat und Jahr berechnen.",
    cat: "Haushalt",
  },
  {
    id: "teppichgroesse",
    name: "Teppichgrößen-Rechner",
    url: "https://rechnerkiste.de/teppichgroesse",
    display: "rechnerkiste.de/teppichgroesse",
    tagline: "Passende Teppichgröße für Esstisch, Sofa, Wohnzimmer oder Bett berechnen.",
    cat: "Wohnen & Einrichten",
  },
  {
    id: "betonrechner",
    name: "Betonrechner",
    url: "https://rechnerkiste.de/betonrechner",
    display: "rechnerkiste.de/betonrechner",
    tagline: "Betonmenge für Bodenplatte, Fundament oder Säule in m³, Säcken und Gewicht berechnen.",
    cat: "Heimwerken",
  },
  {
    id: "prozentrechner",
    name: "Prozentrechner",
    url: "https://rechnerkiste.de/prozentrechner",
    display: "rechnerkiste.de/prozentrechner",
    tagline: "Prozente, Anteile und prozentuale Veränderungen berechnen.",
    cat: "Alltag & Finanzen",
  },
  {
    id: "mehrwertsteuer",
    name: "Mehrwertsteuer-Rechner",
    url: "https://rechnerkiste.de/mehrwertsteuer-rechner",
    display: "rechnerkiste.de/mehrwertsteuer-rechner",
    tagline: "Netto, Brutto und Mehrwertsteuer (19 % / 7 %) umrechnen.",
    cat: "Alltag & Finanzen",
  },
  {
    id: "dreisatz",
    name: "Dreisatz-Rechner",
    url: "https://rechnerkiste.de/dreisatz-rechner",
    display: "rechnerkiste.de/dreisatz-rechner",
    tagline: "Proportional und antiproportional mit dem Dreisatz rechnen.",
    cat: "Alltag & Finanzen",
  },
  {
    id: "zinseszins",
    name: "Zinseszinsrechner",
    url: "https://rechnerkiste.de/zinseszinsrechner",
    display: "rechnerkiste.de/zinseszinsrechner",
    tagline: "Kapitalwachstum mit Zinseszins und Sparrate berechnen.",
    cat: "Alltag & Finanzen",
  },
  {
    id: "stundenlohn",
    name: "Stundenlohn-Rechner",
    url: "https://rechnerkiste.de/stundenlohn-rechner",
    display: "rechnerkiste.de/stundenlohn-rechner",
    tagline: "Monatsgehalt in Stundenlohn umrechnen und zurück.",
    cat: "Alltag & Finanzen",
  },
  {
    id: "rabatt",
    name: "Rabattrechner",
    url: "https://rechnerkiste.de/rabattrechner",
    display: "rechnerkiste.de/rabattrechner",
    tagline: "Rabatt, Endpreis und Ersparnis schnell ausrechnen.",
    cat: "Alltag & Finanzen",
  },
  {
    id: "kiesrechner",
    name: "Kies- & Schüttgut-Rechner",
    url: "https://rechnerkiste.de/kiesrechner",
    display: "rechnerkiste.de/kiesrechner",
    tagline: "Schotter, Kies und Splitt in m³, Tonnen und Big Bags berechnen.",
    cat: "Heimwerken",
  },
  {
    id: "portionsrechner",
    name: "Portionsrechner",
    url: "https://rechnerkiste.de/portionsrechner",
    display: "rechnerkiste.de/portionsrechner",
    tagline: "Mengen pro Person für Reis, Nudeln, Spaghetti und Kartoffeln berechnen.",
    cat: "Küche & Haushalt",
  },
  {
    id: "getraenkerechner",
    name: "Getränkerechner",
    url: "https://rechnerkiste.de/getraenkerechner",
    display: "rechnerkiste.de/getraenkerechner",
    tagline: "Getränkemenge für Party und Feier: Bier, Wein, Sekt, Wasser, Softdrinks.",
    cat: "Küche & Haushalt",
  },
  {
    id: "arbeitszeitrechner",
    name: "Arbeitszeitrechner",
    url: "https://rechnerkiste.de/arbeitszeitrechner",
    display: "rechnerkiste.de/arbeitszeitrechner",
    tagline: "Arbeitszeit aus Beginn, Ende und Pause berechnen.",
    cat: "Alltag & Finanzen",
  },
  {
    id: "quadratmeter",
    name: "Quadratmeter-Rechner",
    url: "https://rechnerkiste.de/quadratmeter-berechnen",
    display: "rechnerkiste.de/quadratmeter-berechnen",
    tagline: "Fläche und Umfang aus Länge und Breite berechnen.",
    cat: "Heimwerken",
  },
  {
    id: "spritkosten",
    name: "Spritkosten-Rechner",
    url: "https://rechnerkiste.de/spritkosten-rechner",
    display: "rechnerkiste.de/spritkosten-rechner",
    tagline: "Spritkosten einer Strecke und pro Person berechnen.",
    cat: "Alltag & Finanzen",
  },
  {
    id: "massstab",
    name: "Maßstab-Rechner",
    url: "https://rechnerkiste.de/massstab-rechner",
    display: "rechnerkiste.de/massstab-rechner",
    tagline: "Zwischen realer Länge und Modell-/Kartenmaß umrechnen.",
    cat: "Heimwerken",
  },
];
